import { createSelector } from 'reselect';

const constructionSelector = (state) => state.Construction;

export default createSelector(
  constructionSelector,
  (construction) => ({
    loaded: construction.parameters_loaded,

    // BACK
    plexiglass_skylight_back_count_available: [...(construction.available.plexiglass_skylight_back_count || [])],
    plexiglass_skylight_back_count_info: construction.info.plexiglass_skylight_back_count,
    plexiglass_skylight_back_count_selected: construction.selected.plexiglass_skylight_back_count,
    plexiglass_skylight_back_size_available: [...(construction.available.plexiglass_skylight_back_size || [])],
    plexiglass_skylight_back_size_info: construction.info.plexiglass_skylight_back_size,
    plexiglass_skylight_back_size_selected: construction.selected.plexiglass_skylight_back_size,

    // LEFT
    plexiglass_skylight_left_count_available: [...(construction.available.plexiglass_skylight_left_count || [])],
    plexiglass_skylight_left_count_info: construction.info.plexiglass_skylight_left_count,
    plexiglass_skylight_left_count_selected: construction.selected.plexiglass_skylight_left_count,
    plexiglass_skylight_left_size_available: [...(construction.available.plexiglass_skylight_left_size || [])],
    plexiglass_skylight_left_size_info: construction.info.plexiglass_skylight_left_size,
    plexiglass_skylight_left_size_selected: construction.selected.plexiglass_skylight_left_size,

    // RIGHT
    plexiglass_skylight_right_count_available: [...(construction.available.plexiglass_skylight_right_count || [])],
    plexiglass_skylight_right_count_info: construction.info.plexiglass_skylight_right_count,
    plexiglass_skylight_right_count_selected: construction.selected.plexiglass_skylight_right_count,
    plexiglass_skylight_right_size_available: [...(construction.available.plexiglass_skylight_right_size || [])],
    plexiglass_skylight_right_size_info: construction.info.plexiglass_skylight_right_size,
    plexiglass_skylight_right_size_selected: construction.selected.plexiglass_skylight_right_size,

    // FRONT ✅ DODANE
    plexiglass_skylight_front_count_available: [...(construction.available.plexiglass_skylight_front_count || [])],
    plexiglass_skylight_front_count_info: construction.info.plexiglass_skylight_front_count,
    plexiglass_skylight_front_count_selected: construction.selected.plexiglass_skylight_front_count,
    plexiglass_skylight_front_size_available: [...(construction.available.plexiglass_skylight_front_size || [])],
    plexiglass_skylight_front_size_info: construction.info.plexiglass_skylight_front_size,
    plexiglass_skylight_front_size_selected: construction.selected.plexiglass_skylight_front_size,
  })
);
